export const Jack = ({ style }) => {
  return (
    <svg viewBox="0 0 264 280" version="1.1" style={style}>
      <defs>
        <circle id="background-circle" cx="120" cy="120" r="120"></circle>
        <path
          d="M12,160 C12,226.27417 65.72583,280 132,280 C198.27417,280 252,226.27417 252,160 L264,160 L264,-1.42108547e-14 L-3.19744231e-14,-1.42108547e-14 L-3.19744231e-14,160 L12,160 Z"
          id="react-path-2"
        ></path>
        <path
          d="M124,144.610951 L124,163 L128,163 L128,163 C167.764502,163 200,195.235498 200,235 L200,244 L0,244 L0,235 C-4.86974701e-15,195.235498 32.235498,163 72,163 L72,163 L76,163 L76,144.610951 C58.7626345,136.422372 46.3722246,119.687011 44.3051388,99.8812385 C38.4803105,99.0577866 34,94.0521096 34,88 L34,74 C34,68.0540074 38.3245733,63.1180731 44,62.1659169 L44,56 L44,56 C44,25.072054 69.072054,5.68137151e-15 100,0 L100,0 L100,0 C130.927946,-5.68137151e-15 156,25.072054 156,56 L156,62.1659169 C161.675427,63.1180731 166,68.0540074 166,74 L166,88 C166,94.0521096 161.51969,99.0577866 155.694861,99.8812385 C153.627775,119.687011 141.237365,136.422372 124,144.610951 Z"
          id="react-path-3"
        ></path>
      </defs>
      <g
        id="Avataaar"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          transform="translate(-825.000000, -1100.000000)"
          id="Avataaar/Circle"
        >
          <g transform="translate(825.000000, 1100.000000)">
            <g
              id="Circle"
              strokeWidth="1"
              fillRule="evenodd"
              transform="translate(12.000000, 40.000000)"
            >
              <mask id="react-mask-4" fill="white">
                <use xlinkHref="#background-circle"></use>
              </mask>
              <use
                id="Circle-Background"
                fill="#E6E6E6"
                xlinkHref="#background-circle"
              ></use>
              <g
                id="Color/Palette/Blue-01"
                mask="url(#react-mask-4)"
                fill="#65C9FF"
              >
                <rect id="🖍Color" x="0" y="0" width="240" height="240"></rect>
              </g>
            </g>
            <mask id="react-mask-5" fill="white">
              <use xlinkHref="#react-path-2"></use>
            </mask>
            <g id="Mask"></g>
            <g strokeWidth="1" fillRule="evenodd" mask="url(#react-mask-5)">
              <g id="Body" transform="translate(32.000000, 36.000000)">
                <mask id="react-mask-6" fill="white">
                  <use xlinkHref="#react-path-3"></use>
                </mask>
                <use fill="#D0C6AC" xlinkHref="#react-path-3"></use>
                <g
                  id="Skin/👶🏽-03-Brown"
                  mask="url(#react-mask-6)"
                  fill="#EDB98A"
                >
                  <g transform="translate(0.000000, 0.000000)" id="Color">
                    <rect x="0" y="0" width="264" height="280"></rect>
                  </g>
                </g>
                <path
                  d="M156,79 L156,102 C156,132.927946 130.927946,158 100,158 C69.072054,158 44,132.927946 44,102 L44,79 L44,94 C44,124.927946 69.072054,150 100,150 C130.927946,150 156,124.927946 156,94 L156,79 Z"
                  id="Neck-Shadow"
                  fillOpacity="0.100000001"
                  fill="#000000"
                  mask="url(#react-mask-6)"
                ></path>
              </g>
              <g transform="translate(0.000000, 170.000000)">
                <defs>
                  <path
                    d="M133.960472,0.294916112 C170.936473,3.32499816 200,34.2942856 200,72.0517235 L200,81 L0,81 L0,72.0517235 C1.22536245e-14,33.9525631 29.591985,2.76498122 67.0454063,0.219526408 C67.0152598,0.593114549 67,0.969227185 67,1.34762511 C67,13.2107177 81.9984609,22.8276544 100.5,22.8276544 C119.001539,22.8276544 134,13.2107177 134,1.34762511 C134,0.994669088 133.986723,0.64370138 133.960472,0.294916112 Z"
                    id="react-path-275"
                  ></path>
                </defs>
                <g id="Shirt" transform="translate(32.000000, 29.000000)">
                  <mask id="react-mask-276" fill="white">
                    <use xlinkHref="#react-path-275"></use>
                  </mask>
                  <use
                    id="Clothes"
                    fill="#E6E6E6"
                    xlinkHref="#react-path-275"
                  ></use>
                  <g
                    id="Color/Palette/Black"
                    mask="url(#react-mask-276)"
                    fill="#262E33"
                  >
                    <g
                      transform="translate(-32.000000, -29.000000)"
                      id="🖍Color"
                    >
                      <rect x="0" y="0" width="264" height="110"></rect>
                    </g>
                  </g>
                  <g
                    id="Shadowy"
                    opacity="0.599999964"
                    mask="url(#react-mask-276)"
                    fillOpacity="0.16"
                    fill="#000000"
                  >
                    <g
                      transform="translate(60.000000, -25.000000)"
                      id="Hola-👋🏼"
                    >
                      <ellipse
                        cx="40.5"
                        cy="27.8476251"
                        rx="39.6351047"
                        ry="26.9138272"
                      ></ellipse>
                    </g>
                  </g>
                </g>
                <g id="Blazer" transform="translate(32.000000, 28.000000)">
                  <path
                    d="M68.784807,1.12222847 C30.512317,2.80409739 -1.89486556e-14,34.3646437 -1.42108547e-14,73.0517235 L0,73.0517235 L0,82 L69.3616767,82 C65.9607412,69.9199941 64,55.7087296 64,40.5 C64,26.1729736 65.7399891,12.7311115 68.784807,1.12222847 Z M131.638323,82 L200,82 L200,73.0517235 C200,34.7067641 170.024954,3.36285166 132.228719,1.17384225 C135.265163,12.7709464 137,26.1942016 137,40.5 C137,55.7087296 135.039259,69.9199941 131.638323,82 Z"
                    id="Saco"
                    fill="#3A4C5A"
                  ></path>
                  <path
                    d="M149,58 L158.555853,50.83311 L158.555853,50.83311 C159.998897,49.7508275 161.987779,49.7682725 163.411616,50.8757011 L170,56 L149,58 Z"
                    id="Pocket-hanky"
                    fill="#E6E6E6"
                  ></path>
                  <path
                    d="M69,1.13686838e-13 C65,19.3333333 66.6666667,46.6666667 74,82 L58,82 L44,46 L50,37 L44,31 L63,1 C65.027659,0.369238637 67.027659,0.0359053037 69,1.13686838e-13 Z"
                    id="Wing"
                    fill="#2F4351"
                  ></path>
                  <path
                    d="M151,1.13686838e-13 C147,19.3333333 148.666667,46.6666667 156,82 L140,82 L126,46 L132,37 L126,31 L145,1 C147.027659,0.369238637 149.027659,0.0359053037 151,1.13686838e-13 Z"
                    id="Wing"
                    fill="#2F4351"
                    transform="translate(141.000000, 41.000000) scale(-1, 1) translate(-141.000000, -41.000000) "
                  ></path>
                </g>
              </g>
              <g
                id="Face"
                transform="translate(76.000000, 82.000000)"
                fill="#000000"
              >
                <g id="Mouth/Smile" transform="translate(2.000000, 52.000000)">
                  <defs>
                    <path
                      d="M35.117844,15.1280772 C36.1757121,24.6198025 44.2259873,32 54,32 C63.8042055,32 71.8740075,24.574136 72.8917593,15.0400546 C72.9736685,14.272746 72.1167429,13 71.042767,13 C56.1487536,13 44.7379213,13 37.0868244,13 C36.0066168,13 35.0120058,14.1784435 35.117844,15.1280772 Z"
                      id="react-path-279"
                    ></path>
                  </defs>
                  <mask id="react-mask-280" fill="white">
                    <use xlinkHref="#react-path-279"></use>
                  </mask>
                  <use
                    id="Mouth"
                    fillOpacity="0.699999988"
                    fill="#000000"
                    fillRule="evenodd"
                    xlinkHref="#react-path-279"
                  ></use>
                  <rect
                    id="Teeth"
                    fill="#FFFFFF"
                    fillRule="evenodd"
                    mask="url(#react-mask-280)"
                    x="39"
                    y="2"
                    width="31"
                    height="16"
                    rx="5"
                  ></rect>
                  <g
                    id="Tongue"
                    strokeWidth="1"
                    fillRule="evenodd"
                    mask="url(#react-mask-280)"
                    fill="#FF4F6D"
                  >
                    <g transform="translate(38.000000, 24.000000)">
                      <circle cx="11" cy="11" r="11"></circle>
                      <circle cx="21" cy="11" r="11"></circle>
                    </g>
                  </g>
                </g>
                <g
                  id="Nose/Default"
                  transform="translate(28.000000, 40.000000)"
                  fillOpacity="0.16"
                >
                  <path
                    d="M16,8 C16,12.418278 21.372583,16 28,16 L28,16 C34.627417,16 40,12.418278 40,8"
                    id="Nose"
                  ></path>
                </g>
                <g
                  id="Eyes/Happy-😁"
                  transform="translate(0.000000, 8.000000)"
                  fillOpacity="0.599999964"
                >
                  <path
                    d="M16.1601674,22.4473116 C18.006676,18.648508 22.1644225,16 26.9975803,16 C31.8136766,16 35.9591217,18.629842 37.8153518,22.4071242 C38.3667605,23.5291977 37.5821037,24.4474817 36.790607,23.7670228 C34.3395063,21.6597833 30.8587163,20.3437884 26.9975803,20.3437884 C23.2572061,20.3437884 19.8737584,21.5787519 17.4375392,23.5716412 C16.5467928,24.3002944 15.6201012,23.5583844 16.1601674,22.4473116 Z"
                    id="Squint"
                  ></path>
                  <path
                    d="M74.1601674,22.4473116 C76.006676,18.648508 80.1644225,16 84.9975803,16 C89.8136766,16 93.9591217,18.629842 95.8153518,22.4071242 C96.3667605,23.5291977 95.5821037,24.4474817 94.790607,23.7670228 C92.3395063,21.6597833 88.8587163,20.3437884 84.9975803,20.3437884 C81.2572061,20.3437884 77.8737584,21.5787519 75.4375392,23.5716412 C74.5467928,24.3002944 73.6201012,23.5583844 74.1601674,22.4473116 Z"
                    id="Squint"
                  ></path>
                </g>
                <g
                  id="Eyebrow/Outline/Up-Down"
                  fillOpacity="0.599999964"
                  fillRule="nonzero"
                >
                  <path
                    d="M15.5914402,14.1619718 C20.0874642,7.83556966 29.6031809,4.65350252 39.3473715,7.79575991 C40.3986323,8.13476518 41.5256656,7.55736801 41.8646708,6.50610724 C42.2036761,5.45484647 41.6262789,4.32781316 40.5750182,3.98880789 C29.1665516,0.309863172 17.8358054,4.09887835 12.3309495,11.8448183 C11.6910852,12.7451779 11.9022584,13.9937761 12.8026181,14.6336404 C13.7029777,15.2735046 14.9515759,15.0623314 15.5914402,14.1619718 Z"
                    id="Eyebrow"
                  ></path>
                  <path
                    d="M73.6376405,21.1577995 C77.5525501,15.6490895 88.2853148,12.56006 97.5304219,14.8304032 C98.6031199,15.0938282 99.6862617,14.4377829 99.9496867,13.3650849 C100.213112,12.2923868 99.5570664,11.2092451 98.4843684,10.9458201 C87.7477584,8.30920485 75.3194947,11.8862211 70.3771498,18.840646 C69.7372855,19.7410057 69.9484587,20.9896038 70.8488184,21.6294681 C71.749178,22.2693324 72.9977762,22.0581591 73.6376405,21.1577995 Z"
                    id="Eyebrow"
                    transform="translate(85.007549, 16.038421) scale(-1, 1) translate(-85.007549, -16.038421) "
                  ></path>
                </g>
              </g>
              <g id="Top" strokeWidth="1" fillRule="evenodd">
                <defs>
                  <rect
                    id="react-path-229"
                    x="0"
                    y="0"
                    width="264"
                    height="280"
                  ></rect>
                  <path
                    d="M90.9102919,55.3613196 L175.085702,55.3613196 C193.333279,44.8338001 196.759397,26.1510357 183.849606,9.92600089 C180.635746,5.88682054 175.085702,21.6755614 158.028596,22.6504878 C140.97149,23.6254143 142.608865,16.3498661 124.45759,19.0739248 C106.306316,21.7979835 108.311575,36.37843 96.4671989,39.8768239 C88.5709482,42.2090865 86.7186458,47.370585 90.9102919,55.3613196 Z"
                    id="react-path-228"
                  ></path>
                  <filter
                    x="-0.8%"
                    y="-2.0%"
                    width="101.5%"
                    height="108.0%"
                    filterUnits="objectBoundingBox"
                    id="react-filter-225"
                  >
                    <feOffset
                      dx="0"
                      dy="2"
                      in="SourceAlpha"
                      result="shadowOffsetOuter1"
                    ></feOffset>
                    <feColorMatrix
                      values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0"
                      type="matrix"
                      in="shadowOffsetOuter1"
                      result="shadowMatrixOuter1"
                    ></feColorMatrix>
                    <feMerge>
                      <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                      <feMergeNode in="SourceGraphic"></feMergeNode>
                    </feMerge>
                  </filter>
                </defs>
                <mask id="react-mask-227" fill="white">
                  <use xlinkHref="#react-path-229"></use>
                </mask>
                <g id="Mask"></g>
                <g id="Top/Short-Hair/Frizzle" mask="url(#react-mask-227)">
                  <g transform="translate(-1.000000, 0.000000)">
                    <mask id="hair-mask" fill="white">
                      <use xlinkHref="#react-path-228"></use>
                    </mask>
                    <use
                      id="Hair-Maks"
                      stroke="none"
                      fill="#252E32"
                      fillRule="evenodd"
                      xlinkHref="#react-path-228"
                    ></use>
                    <g
                      id="Skin/👶🏽-03-Brown"
                      mask="url(#hair-mask)"
                      fill="#4A312C"
                    >
                      <g transform="translate(0.000000, 0.000000) " id="Color">
                        <rect x="0" y="0" width="264" height="280"></rect>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
